@if (hasConfigurations()) {
  <button
    [matBadge]="numberOfAppliedFilters()"
    [matBadgeHidden]="numberOfAppliedFilters() === 0"
    [matBadgeColor]="'warn'"
    [matBadgeOverlap]="true"
    mat-button
    mat-stroked-button
    (click)="openFilterDialog()"
  >
    <mat-icon>filter_list</mat-icon>
    {{ 'context.config' | translate }}
  </button>
}
